import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <section id="faq" className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Frequently asked</div>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
            A few things to <span className="italic text-[#985F47]">know.</span>
          </h2>
        </div>

        <div className="reveal">
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem
                key={f.id || i}
                value={`item-${i}`}
                className="border-b border-[#2C392F]/15"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="serif text-xl md:text-2xl text-[#2C392F] hover:no-underline text-left py-6 group"
                >
                  {f.question}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-[#4A4D4A] text-base leading-relaxed pb-6 pr-8 max-w-3xl"
                >
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
